import { EMPTY } from "../../Constants";

const initialState = {
  loggedInUser: EMPTY,
  registeredUser: EMPTY,
  userInfo: {},
  currentSession: EMPTY,
};

const getUserDetails = (state = initialState, action) => {
  switch (action.type) {
    case "SET_LOGGED_IN_USER_EMAIL":
      return {
        ...state,
        loggedInUser: action.email,
      };
    case "SET_REGISTERED_USER_EMAIL":
      return {
        ...state,
        registeredUser: action.email,
      };
    case "SET_USER_DETAILS":
      return {
        ...state,
        userInfo: action.userInfo,
      };
    case "RESET_USER_STATE":
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default getUserDetails;
